import { BaseSearchModel } from '../../../core/base/base-search.model';

export class ForgetPasswordModel extends BaseSearchModel {

      username: any;
      Question: any;
      Answer: any;

}



// WEBPACK FOOTER //
// ./src/app/pages/login/forget-password/forget-password.model.ts